import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import vi from "./nailEvent.vi.json";
import en from "./nailEvent.en.json";

const DICTS = { vi, en };
const STORAGE_KEY = "nailEvent.lang";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "vi";
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "en" ? "en" : "vi";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === "vi" || next === "en") setLangState(next);
  }, []);

  const t = useCallback(
    (path, fallback) => {
      const parts = path.split(".");
      let cur = DICTS[lang];
      for (const p of parts) {
        if (cur && Object.prototype.hasOwnProperty.call(cur, p)) cur = cur[p];
        else return fallback ?? path;
      }
      return cur ?? fallback ?? path;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
